import { MouseEvent, PropsWithChildren, useState } from "react";
import { Menu } from "@mui/material";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { UppercaseButton } from "../../Layout/Buttons/UppercaseButton";
import { KENDO_BUTTON_CLASSES } from "../../Layout/Buttons/KendoButtons";
import { IconWithRightMargin } from "../../Layout/Icons/IconWithRightMargin";

interface ToolbarDropdownMenuProps {
  text: string;
}

export function ToolbarDropdownMenu({
  text,
  children,
}: PropsWithChildren<ToolbarDropdownMenuProps>) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const openMenu = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <UppercaseButton
        type="button"
        className={KENDO_BUTTON_CLASSES}
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={openMenu}
      >
        <IconWithRightMargin icon={faChevronDown} />
        {text}
      </UppercaseButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {children}
      </Menu>
    </div>
  );
}
